import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import '../../styles/sections/sectorApply.css';
import '../../styles/fonts.css';
import { sectorImages } from '../../constants/images';
import { checkIsMobile } from '../../utils/deviceUtils';
import { APPLICATION_START_DATE } from '../../constants/configLoader';
import { calculateTimeLeft } from '../../utils/timeUtils';
import '../../styles/sections/sector02.css';
import CountDown from '../common/CountDown';

const SectorApply = ({ motionProps }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const [isMobile, setIsMobile] = useState(checkIsMobile(window.innerWidth));
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // 초기 계산
    setTimeLeft(calculateTimeLeft(APPLICATION_START_DATE));
    
    // 1초마다 업데이트
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft(APPLICATION_START_DATE));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(checkIsMobile(width));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const pluralize = (count, word) => {
    return `${count} ${word}${count !== 1 ? 's' : ''}`;
  };

  const bgImage = sectorImages.sectorApply.bg[isMobile ? 'mobile' : 'pc'];

  return (
    <section 
      className="section_container bg_img_sec sector_apply_section" 
      {...motionProps}
      style={{ backgroundImage: `url(${bgImage})` }}
      id="sector_apply"
    >
      <motion.div 
        className="apply_container"
      >
        <CountDown 
          showTitle={true}
          isMobile={isMobile}
          titleImage={sectorImages.sectorApply.title[isMobile ? 'mobile' : 'pc']}
        />
        <div className="btn_wrapper_in_sector_apply">
          <Link to="/apply" className="apply_btn">
            <img
              src={sectorImages.sectorApply.button[isMobile ? 'mobile' : 'pc']}
              alt="Apply Now"
              className={isMobile ? 'mo_viewer' : 'pc_viewer'}
            />
          </Link>
        </div>
      </motion.div>
    </section>
  );
};

SectorApply.propTypes = {
  motionProps: PropTypes.shape({
    initial: PropTypes.object,
    whileInView: PropTypes.object,
    exit: PropTypes.object,
    viewport: PropTypes.object,
    transition: PropTypes.object
  }).isRequired
};

export default SectorApply; 